import React from 'react'

import PageHeader from '@components/PageHeader/PageHeader'

const AccessDenied = () =>
	<main className="AccessDenied page-content">
		<PageHeader title="Access Denied" />
		<div>You do not have permission to view this resoure</div>
	</main>

export default AccessDenied;


// WEBPACK FOOTER //
// ./src/scenes/AccessDenied/AccessDenied.jsx